import { memo, useSyncExternalStore } from 'react';
import { useAudioOverlay } from './useAudioOverlay';
import { timelineActionsStore } from '../../ClipNewTimeline/store/timelineActions';
import FilesInput from '@/components/atoms/inputs/FilesInput/FilesInput';

const AudioOverlay = ({ onUploadComplete }: { onUploadComplete: () => void }) => {
  const { isAddingAudio } = useSyncExternalStore(timelineActionsStore.subscribe, timelineActionsStore.getSnapshot);
  const { uploadAudio, acceptedFormats } = useAudioOverlay();

  const onFilesUpload = async (files: File[]) => {
    await uploadAudio(files);
    onUploadComplete?.();
  };

  return (
    <FilesInput
      onFilesUpload={onFilesUpload}
      accept={acceptedFormats}
      title={isAddingAudio ? 'Uploading...' : 'Upload Audio'}
      variant="button"
      multiple={false}
      iconClassNames={isAddingAudio ? 'animate-spin' : ''}
      icon={isAddingAudio ? 'IconLoader2' : 'IconUpload'}
      isDisabled={isAddingAudio}
    />
  );
};

export default memo(AudioOverlay);
